import {
  Module,
  VuexModule,
  getModule,
  Mutation,
  Action
} from "vuex-module-decorators";
import { Transportadora } from "@/models/transportadora";
import store from "@/store";
import TransportadoraAuth from "@/services/transportadora.auth.service"

@Module({
  dynamic: true,
  namespaced: true,
  name: "transportadora",
  store
})
class TransportadoraModule extends VuexModule {
  transportadora: Transportadora;
  veiculoTransportadoraId:number;

  @Mutation
  setTransportadora(transportadora: Transportadora): void {
    this.transportadora = transportadora;
  }
  @Mutation
  setVeiculoTransportadoraId(veiculoTransportadoraId: number): void {
    this.veiculoTransportadoraId = veiculoTransportadoraId;
  }
}

export default getModule(TransportadoraModule);
